import gql from 'graphql-tag'

export const getVehicles = gql`
  query($paging: PagingQuery, $order: VehiclesOrder, $filter: VehiclesFilter!) {
    getVehicles(
      filter: $filter,
      order: $order,
      paging: $paging
    ) {
      vehicles {
        id
        name
        vin
        year
        make
        loan
        model
        notes
        vehicleCoverage
        roadsideTowing
        rentalCarCoverage
        createdAt
        updatedAt
        ownership
        useage
        mileage
        lastModifiedBy {
          id
          username
        }
        createdBy {
          id
          username
        }
        quote {
          id
          name
        }
        policy {
          id
          policyName
        }
        lienHolder {
          name
          insuranceDepartment
          address
          phoneNumber
          notes
        }
      }
      paging { totalCount currentOffset currentLimit }
    }
  }
`

export const getVehicle = gql`
  query($vehicleId: Int!) {
    getVehicle(
      vehicleId: $vehicleId
    ) {
      id
      name
      vin
      year
      make
      loan
      model
      notes
      vehicleCoverage
      roadsideTowing
      rentalCarCoverage
      ownership
      useage
      mileage
      createdAt
      updatedAt
      quote {
        id
        name
      }
      policy {
        id
        policyName
      }
      lienHolder {
        name
        insuranceDepartment
        address
        phoneNumber
        notes
      }
      createdBy {
        id
        username
      }
      lastModifiedBy {
        id
        username
      }
    }
  }
`

export const newVehicle = gql`
  mutation($vehicleInput: VehicleInput!) {
    newVehicle(
      vehicleInput: $vehicleInput
    ) {
      id,
      name
    }
  }
`

export const editVehicle = gql`
  mutation($vehicleInput: VehicleInput!, $vehicleId: Int!) {
    editVehicle(
      vehicleInput: $vehicleInput,
      vehicleId: $vehicleId
    ) {
      id,
      name
    }
  }
`

export const deleteVehicle = gql`
  mutation($vehicleId: Int!) {
    deleteVehicle(
      vehicleId: $vehicleId
    )
  }
`
